import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import { WithPermissions } from 'react-admin';
import { getDecodedToken } from '../token';
import { Intercom } from '../utils';

const Dashboard = ({ history }) => {
  useEffect(() => {
    history.listen(() => {
      Intercom.update();
    });
  });
  return (
    <WithPermissions render={({ permissions }) => {
      const {
        status: status,
        stripe_subscription_started: stripeSubscriptionStarted,
      } = getDecodedToken() || {};

      if (!permissions) return null;

      if ((status === 'waiting_for_payment' || status === 'expiring' || status === 'inactive')
        && !stripeSubscriptionStarted) {
        return <Redirect to={'/subscription'}/>;
      }

      return (permissions === 'ROLE_ADMIN'
        ? <Redirect to={'/accounts'}/>
        : <Redirect to={'/websites'}/>);
    }}
    />
  );
};

export default withRouter(Dashboard);
